module.exports = __webpack_public_path__ + "static/media/fivehundredassists.0cf1e054.jpg";